module.exports = __webpack_public_path__ + "static/media/earning.f8d8d664.png";